export const environment = {
  production: true,
  pushNotificationsEnabled: false,
  version: "2.0.2-152435",
  featureFlag: {
    co2: true,
  },
  dependencies: {
    domain: "tmeshdev.bitme.sh",
    signal_api: {
      url: "https://tapi.bitme.sh/signal",
      domain: "tapi.bitme.sh",
    },
    entity_api: {
      url: "https://tapi.bitme.sh/entity",
      domain: "tapi.bitme.sh",
    },
    security_api: {
      url: "https://tapi.bitme.sh/security",
      domain: "tapi.bitme.sh",
    },
    notifications_api: {
      url: "https://tapi.bitme.sh/entity",
      domain: "tapi.bitme.sh",
    },
    termoobject_api: {
      url: "https://tapi.bitme.sh/entity",
      domain: "tapi.bitme.sh",
    },
    tempreports_api: {
      url: "https://tapi.bitme.sh/tempcontrol",
      domain: "tapi.bitme.sh",
    },
    checklist_api: {
      url: "https://tapi.bitme.sh/checklist",
      domain: "tapi.bitme.sh",
    },
    signature_api: {
      url: "https://tapi.bitme.sh/checklist",
      domain: "tapi.bitme.sh",
    },
    fileupload_api: {
      url: "https://tapi.bitme.sh/file",
      domain: "tapi.bitme.sh",
    },
  },
  clientId: 'ad5c663b-e9a1-41d6-b9c2-21276dbb29db',
  redirectUrl: 'https://tmeshdev.bitme.sh/login',
  protectedResourceMap: new Map<string, Array<string>>([
    [
      "https://tapi.bitme.sh/signal", ["api://c0570187-e61a-46da-b197-1007ee995a7d/Admin"],
    ],
    [
      "https://tapi.bitme.sh/entity", ["api://c0570187-e61a-46da-b197-1007ee995a7d/Admin"],
    ],
    [
      "https://tapi.bitme.sh/file", ["api://c0570187-e61a-46da-b197-1007ee995a7d/Admin"],
    ],
    [
      "https://tapi.bitme.sh/tempcontrol", ["api://c0570187-e61a-46da-b197-1007ee995a7d/Admin"],
    ],
    [
      "https://tmeshdev.bitme.sh", ["api://c0570187-e61a-46da-b197-1007ee995a7d/Admin"],
    ],
    [
      "https://tapi.bitme.sh/checklist", ["api://c0570187-e61a-46da-b197-1007ee995a7d/Admin"],
    ],
    [
      "https://tapi.bitme.sh/security", ["api://c0570187-e61a-46da-b197-1007ee995a7d/Admin"],
    ],
  ]),
};
